import { DraftWaypointStatus, WaypointStatusName } from '@caresend/types';
import { isDraftWaypointDenormalized, getSupplyInstructionConfigOptionsPath, hasStatus, getWaypointDateTimeLabels, getDraftWaypointDateTimeLabels } from '@caresend/utils';
import 'firebase/auth';
import '../../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../../database/firebaseConfig/init.js';
import { firebaseBind, firebaseUnbind } from '../../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../../ui/Icon.vue.js';
import '../../../../../functions/configuration/icons.js';
import '../../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../../functions/tracking/index.js';
import '../../../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import '../../../portal/store/portal/sessionStore.js';
import 'vue';
import 'file-saver';
import '../../../../../database/encryption/model.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../../../portal/store/storeUtilities/dbSync/dbSyncStore.js';
import { isPatientUser } from '../../../../../store/helpers.js';
import 'firebase/database';
import 'immutability-helper';
import '../../../../../router/routes/dev/model.js';
import '../../../../../router/routes/dev/routes.js';
import '../../../../../router/routes/dashboard/model.js';
import '../../../../../router/routes/pro/model.js';
import '../../../../../router/routes/visitsPage/model.js';
import '../../../../../router/routes/orderFlow/model.js';
import '../../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../../router/routes/orderFlow/routes.js';
import '../../../../../router/routes/schedulingFlow/model.js';
import '../../../../../router/routes/schedulingFlow/routes.js';
import '../../../../../router/routes/chartingFlow/model.js';
import '../../../../../router/routes/chartingFlow/routes.js';
import '../../../../../router/routes/portal/portalRoutes.js';
import '../../../../../router/routes/portal/model.js';
import '../../../../../router/routes/visitsPage/routes.js';
import '../../../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../../../store/modules/app/model.js';
import '../../../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../../../store/pinia/draftWaypoints/index.js';
import '../../../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../../../store/modules/chartingFlow/model.js';
import '../../../../../store/modules/office/index.js';
import '../OrdersVisitsFilters/model.js';
import '../../../../../store/modules/office/model.js';
import '../../../../../store/modules/orderFlow/index.js';
import '../../../../../store/modules/procedures/model.js';
import '../../../../../store/modules/schedulingFlow/index.js';
import '../../../../../store/modules/schedulingFlow/model.js';

const isSchedulingFilterReady = async (draftWaypoint) => {
    const firstProcedureID = isDraftWaypointDenormalized(draftWaypoint)
        ? draftWaypoint.procedureIDs[0]
        : Object.keys(draftWaypoint.procedures)[0];
    if (!firstProcedureID)
        return false;
    const schedulingFiltersPath = getSupplyInstructionConfigOptionsPath(firstProcedureID, 'schedulingFilters');
    return new Promise((resolve) => {
        firebaseBind(schedulingFiltersPath, (schedulingFilters) => {
            if (!schedulingFilters) {
                resolve(false);
                return;
            }
            firebaseUnbind(schedulingFiltersPath);
            resolve(true);
        });
    });
};
const getWaypointCardTitle = (
/** Draft waypoint only passed in case of just-created order in pro. */
draftWaypoint, 
/** We probably could add this to denormalized draftWaypoints in the future */
offlineScheduling, placeName) => {
    if (hasStatus(draftWaypoint, DraftWaypointStatus.CANCELED))
        return 'Visit canceled';
    if (hasStatus(draftWaypoint, DraftWaypointStatus.REJECTED))
        return 'Visit rejected';
    /**
     * Toby has confirmed that this is the specific text we want in this situation
     * for now
    */
    if (offlineScheduling)
        return 'Blood Draw';
    const patientWaypointInfo = isDraftWaypointDenormalized(draftWaypoint)
        ? draftWaypoint.patientWaypointInfo
        : {};
    const { status, transitInfo } = patientWaypointInfo !== null && patientWaypointInfo !== void 0 ? patientWaypointInfo : {};
    if (status && transitInfo) {
        const { dateLabel, arrivalTimeLabel, completionTimeLabel } = getWaypointDateTimeLabels(status, transitInfo);
        if (hasStatus(status, WaypointStatusName.COMPLETE)) {
            return `Completed ${dateLabel} at ${completionTimeLabel}`;
        }
        if (hasStatus(status, WaypointStatusName.AT_WAYPOINT)) {
            return `Nurse arrived on ${dateLabel} at ${arrivalTimeLabel}`;
        }
    }
    const { dateLabel, timeLabel } = getDraftWaypointDateTimeLabels(draftWaypoint);
    if (placeName)
        return `Visit to ${placeName}`;
    if (dateLabel && timeLabel)
        return `Nurse visit on ${dateLabel}, ${timeLabel}`;
    return 'Visit';
};
const getWaypointCardSubtitle = (
/** Draft waypoint only passed in case of just-created order in pro. */
draftWaypoint, isCurrentUserSchedulingUser, offlineScheduling, facilityDetails, schedulingUserName) => {
    var _a, _b;
    if (hasStatus(draftWaypoint, DraftWaypointStatus.REJECTED))
        return '';
    if (offlineScheduling) {
        /**
         * If we expand on offlineScheduling in the future then we will need to
         * add more complex logic here to determine the location to display
         */
        return 'Puerto Rico';
    }
    const subtitleParts = [];
    let address;
    if (facilityDetails) {
        address = (_a = facilityDetails.location) === null || _a === void 0 ? void 0 : _a.formattedAddress;
    }
    else {
        address = (_b = draftWaypoint.location) === null || _b === void 0 ? void 0 : _b.formattedAddress;
    }
    if (hasStatus(draftWaypoint.status, DraftWaypointStatus.PENDING)) {
        let schedulingPrompt;
        if (isCurrentUserSchedulingUser) {
            // Cards are only tappable in patient. Pro users have a separate
            // Schedule button
            schedulingPrompt = isPatientUser()
                ? 'Tap here to schedule'
                : 'Scheduling user will provide the address';
        }
        else if (schedulingUserName) {
            schedulingPrompt = `${schedulingUserName} was sent a link to schedule`;
        }
        else {
            schedulingPrompt = 'Scheduling user will provide the address';
        }
        subtitleParts.push(schedulingPrompt);
    }
    else if (address) {
        subtitleParts.push(address);
    }
    return subtitleParts.join('\n');
};

export { getWaypointCardSubtitle, getWaypointCardTitle, isSchedulingFilterReady };
